import { useMutation } from 'react-query';
import { visitRequest } from '@services/VisitRequest/VisitRequest';
import { AxiosError } from 'axios';

export const useVerifyRequestStatus = () => {
  return useMutation<unknown, AxiosError, string>(async (requestId: string) => {
    const { data } = await visitRequest.verifyRequestStatus({ requestId: requestId });
    return data;
  });
};
